import theme, { createAppTheme } from '@/theme'
import { applyCompanyTheme } from '@/theme/company-theme-map'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { ReactNode, useCallback, useState } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ApplicationSettingsProvider } from './application/application-settings-provider'
import { AccountProvider } from './auth/account-provider'
import { queryClient } from '@/infra/http'

type AppProvidersProps = {
  children: ReactNode
}

export default function AppProviders({ children }: AppProvidersProps) {
  const [muiTheme, setMuiTheme] = useState(theme)

  const onCompanyLoaded = useCallback((companyUniqueId: string) => {
    applyCompanyTheme(companyUniqueId)
    // defer to ensure browser has processed the new CSS class before reading vars
    requestAnimationFrame(() => setMuiTheme(createAppTheme()))
  }, [])

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AccountProvider onCompanyLoaded={onCompanyLoaded}>
          <ApplicationSettingsProvider>{children}</ApplicationSettingsProvider>
        </AccountProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
